import { render, staticRenderFns } from "./registro-rubro.vue?vue&type=template&id=92ec6394&scoped=true&"
import script from "./registro-rubro.vue?vue&type=script&lang=js&"
export * from "./registro-rubro.vue?vue&type=script&lang=js&"
import style0 from "./registro-rubro.vue?vue&type=style&index=0&id=92ec6394&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92ec6394",
  null
  
)

export default component.exports